<div class="Txt-Outrights">
  <h2>{{ 'Results' | t }}</h2>
  <span>{{ 'results_desc' | t }}</span>

  <form class="example-container" style="width: 100%; margin-top: 10px">
    <div style="width: 100%">
      <mat-form-field style="width: 100%">
        <mat-select placeholder="{{ 'Sports' | t }}">
          <mat-option *ngFor="let item of this.resultSportsList" (click)="getResultCategories(item.SportId)" value="{{ item.SportId }}">{{ item.SportName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="width: 100%">
      <mat-form-field *ngIf="this.resultCategoriesList.length > 0" style="width: 100%">
        <mat-select placeholder="{{ 'country' | t }}">
          <mat-option *ngFor="let item of this.resultCategoriesList" (click)="getTournamentsByCategoryId(item.CategoryId, this.sportId)" value="item.CategoryId">{{
            item.CategoryName
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="width: 100%">
      <mat-form-field *ngIf="this.resultsTournamentsList.length > 0" style="width: 100%">
        <mat-select placeholder="{{ 'Tournament' | t }}">
          <mat-option
            *ngFor="let item of this.resultsTournamentsList"
            (click)="getResultsList(item.CategoryId, item.TournamentId, item.TournamentName)"
            value="{{ item.MatchId }}"
            >{{ item.TournamentName }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <mat-card *ngFor="let item of this.resultList" style="margin-bottom: 5px; padding: 1px; padding-bottom: 5px">
      <mat-grid-list cols="16" rowHeight="20px" style="font-size: 12px">
        <mat-grid-tile colspan="16">
          {{ item.EventDate }}
        </mat-grid-tile>
        <mat-grid-tile colspan="6" rowspan="2" style="font-weight: bold">
          <div style="position: absolute; left: 5px">
            {{ item.HomeTeam }}
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="4" rowspan="1" style="font-weight: bold">
          {{ item.FTScore }}
        </mat-grid-tile>

        <mat-grid-tile colspan="6" rowspan="2" style="font-weight: bold">
          <div style="position: absolute; right: 5px">
            {{ item.AwayTeam }}
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="4" rowspan="1" style="font-weight: bold">
          <ng-container *ngIf="item.HTScore !== ''">({{ item.HTScore }})</ng-container>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>
  </form>
</div>

<!--<div style="margin:5px">

  <mat-grid-list cols="16" rowHeight="30px" style="font-size:12px;font-weight:bold" *ngIf="this.resultList.length > 0">
    <mat-grid-tile colspan="2">
      {{'Date' | t}}
    </mat-grid-tile>
    <mat-grid-tile colspan="5">
      <div style="position: absolute;left: 5px;">
        {{'Home_Team' | t}}
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5">
      <div style="position: absolute;left: 5px;">
        {{'Away_Team' | t}}
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
      HT
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
      FT
    </mat-grid-tile>
  </mat-grid-list>


  <mat-grid-list cols="16" rowHeight="30px" *ngFor="let item of this.resultList" style="font-size:12px">
    <mat-grid-tile colspan="2">
      {{item.EventDate}}
    </mat-grid-tile>
    <mat-grid-tile colspan="5">
      <div style="position: absolute;left: 5px;">
        {{item.HomeTeam}}
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="5">
      <div style="position: absolute;left: 5px;">
        {{item.AwayTeam}}
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
      {{item.HTScore}}
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
      {{item.FTScore}}
    </mat-grid-tile>
  </mat-grid-list>

</div>-->
